// eslint-disable-next-line prefer-regex-literals
const EMAIL_REGULAR_EXPRESION = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
export const emailChecker = (value: string) => EMAIL_REGULAR_EXPRESION.test(value);
